import { NgModule } from "@angular/core";
import { MSAL_INSTANCE, MsalService } from "@azure/msal-angular";
import { BrowserCacheLocation, IPublicClientApplication, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { ENVIRONMENT } from "src/environments/environment";

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    MsalService,
  ],
})
export class SsoModule {}

export function MSALInstanceFactory(): IPublicClientApplication {
  const clientId = ENVIRONMENT.MSAL?.clientId || "";
  let authority = "";

  if (ENVIRONMENT.MSAL?.authority) {
    authority = ENVIRONMENT.MSAL.authority;
  } else {
    authority = `https://login.microsoftonline.com/${ENVIRONMENT.MSAL?.tenantId}`;
  }

  return new PublicClientApplication({
    auth: ENVIRONMENT.MSAL?.knownAuthorities
      ? {
          clientId: clientId,
          authority: authority,
          knownAuthorities: ENVIRONMENT.MSAL?.knownAuthorities,
          redirectUri: "/login/sso",
          postLogoutRedirectUri: "/",
        }
      : {
          clientId: clientId,
          authority: authority,
          redirectUri: "/login/sso",
          postLogoutRedirectUri: "/",
        },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (a, b) => console.log(b),
        logLevel: LogLevel.Error,
        piiLoggingEnabled: true,
      },
      allowNativeBroker: false,
    },
  });
}
